/**
 * Settings panel open/close behaviour and its keyboard shortcuts.
 *
 * The panel is a floating, scrim-less card so the globe stays interactive
 * while it is open. It is opened only via Cmd/Ctrl+i and closed via the X
 * button or Escape; the in-panel toggle switches that control globe features
 * live in the globe core, not here.
 */
export function initSettingsDrawer(): void {
  const settingsDrawer = document.getElementById('settings-drawer')
  const settingsDrawerClose = document.getElementById('settings-drawer-close')
  if (!settingsDrawer) return

  function open(): void {
    settingsDrawer.classList.add('open')
  }

  function close(): void {
    settingsDrawer.classList.remove('open')
  }

  if (settingsDrawerClose) {
    settingsDrawerClose.addEventListener('click', close)
  }

  document.addEventListener('keydown', (e) => {
    // Escape to close
    if (e.key === 'Escape' && settingsDrawer.classList.contains('open')) {
      close()
    }
    // Cmd+i (Mac) or Ctrl+i (Windows/Linux) to toggle
    if (e.key === 'i' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault()
      if (settingsDrawer.classList.contains('open')) {
        close()
      } else {
        open()
      }
    }
  })
}
